import React from 'react';
import { StatusIndicator, Link } from '@amzn/awsui-components-react-v3';
import {
    classroomStatusAlertMap,
    CLASSROOM_CONSTANTS,
} from './ClassroomsHelper';
import { EMPTY_STRING } from '../../../../../common/constants/grimsby';

const renderClassroomStatusMessage = (status: string, course: string) => {
    const courseName = course || '';

    const isUnsupported = CLASSROOM_CONSTANTS.UNSUPPORTED_COURSES.includes(
        course.toLowerCase(),
    );

    if (isUnsupported) {
        return (
            <>
                <StatusIndicator type="warning">
                    {CLASSROOM_CONSTANTS.MESSAGES.UNSUPPORTED_COURSE}{' '}
                    <Link
                        href={CLASSROOM_CONSTANTS.URLS.CLASSROOMS_PORTAL}
                        external={true}
                        externalIconAriaLabel="Opens in a new tab"
                    >
                        {CLASSROOM_CONSTANTS.MESSAGES.CREATE_MANUALLY}
                    </Link>
                </StatusIndicator>
            </>
        );
    }

    if (!status || !classroomStatusAlertMap[status]) {
        return EMPTY_STRING;
    }

    return (
        <>
            <StatusIndicator type={classroomStatusAlertMap[status].type}>
                {classroomStatusAlertMap[status].message}
            </StatusIndicator>
        </>
    );
};

export default renderClassroomStatusMessage;
